'use client';

import { buildImageProxyUrlByObjectName } from 'components/AiTools/utils';
import { getUseCaseData } from 'global/utils/templates/getUseCaseData';
import { findSubUseCase, findUseCase } from 'global/utils/useCaseUtils';
import { PageType, PageTypes } from 'strapi/page/types';

export const enrichWithUseCaseImageParams = async (
  pageType: PageType,
  page: PageTypes
): Promise<PageTypes> => {
  if (
    pageType !== PageType.AiWritingToolChildPage ||
    !('carousel' in page) ||
    !page.carousel ||
    // This enricher now is used only for templates_use_case_pages and templates_sub_use_case_pages fields
    // The page should have at least one templates_use_case_page or templates_sub_use_case_page linked
    !(
      page.carousel.templates_use_case_pages?.length ||
      page.carousel.templates_sub_use_case_pages?.length
    )
  ) {
    return page;
  }

  const useCases = await getUseCaseData();

  page.carousel.templates_use_case_pages =
    page.carousel.templates_use_case_pages?.map((x) => {
      const useCase = findUseCase(useCases, x.use_case.slug);
      const preview = useCase?.imagePaths?.categoryPageImage;
      if (!preview) {
        return {
          ...x,
          cover: '/images/category/all-new.png',
        };
      }

      return {
        ...x,
        cover: buildImageProxyUrlByObjectName(preview),
      };
    });

  page.carousel.templates_sub_use_case_pages =
    page.carousel.templates_sub_use_case_pages?.map((x) => {
      const defaultCover = '/images/category/all-new.png';

      const useCase = findUseCase(useCases, x.sub_use_case.use_case.slug);
      if (!useCase) {
        return {
          ...x,
          cover: defaultCover,
        };
      }
      const subUseCase = findSubUseCase(useCase, x.sub_use_case.slug);
      const preview = subUseCase?.imagePaths?.categoryPageImage;
      if (!preview) {
        return {
          ...x,
          cover: defaultCover,
        };
      }

      return {
        ...x,
        cover: buildImageProxyUrlByObjectName(preview),
      };
    });

  return page;
};
